import { Col, Divider, Row } from 'antd';
import propTypes from 'prop-types';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '../../../components/buttons/buttons';
import DivBreak from '../../../components/divBreak/DivBreak';
import FormUpload from '../../../components/upload/FormUpload';
import { MODAL_TYPE } from '../Car';
import { deleteCarFile } from '../../../redux/car/actionCreator';
import { IMAGE_URL } from '../../../utils/constants';
import DeleteConfirmationModal from '../../../components/modals/DeleteConfirmationModal';

const CarFieldForm = props => {
  const { values, setFieldValue, keyNameAndValue, cancelModal, formData } = props;

  const params = useParams();
  const dispatch = useDispatch();
  const deleteImageLoading = useSelector(state => state.car.loading);

  const [deleteFile, setDeleteFile] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  function getAcceptType() {
    switch (keyNameAndValue?.name) {
      case MODAL_TYPE.carSounds:
        return 'audio/mp3,audio/*;capture=microphone';
      case MODAL_TYPE.technicalVisitCertificate:
        return 'application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*';
      case MODAL_TYPE.keys:
        return 'image/*';
      default:
        return null;
    }
  }

  const onCancel = () => {
    setShowDeleteModal(false);
    setDeleteFile(null);
    setFieldValue(`${keyNameAndValue?.value}`, formData[keyNameAndValue?.value]);
  };

  const handleDeleteClick = file => {
    // eslint-disable-next-line no-underscore-dangle
    if (values?._id) {
      if (file?.originFileObj) return;
      setShowDeleteModal(true);
      setDeleteFile(file);
    }
  };

  const handleDeleteConfirmation = async () => {
    const res = await dispatch(deleteCarFile(params?.id, deleteFile?.name, `${keyNameAndValue?.value}`));
    if (res?.data && res?.data?.status) {
      const respFileStr = res?.data?.car[`${keyNameAndValue?.value}`];
      const respFile = respFileStr
        ? [
            {
              uid: '-1',
              name: `${respFileStr}`,
              status: 'done',
              url: `${IMAGE_URL}/${respFileStr}`,
            },
          ]
        : [];
      setFieldValue(`${keyNameAndValue?.value}`, respFile);
      setShowDeleteModal(false);
    }
    setDeleteFile(null);
  };

  return (
    <>
      <DeleteConfirmationModal
        title={keyNameAndValue?.name}
        visible={showDeleteModal}
        onCancel={onCancel}
        handleDeleteConfirmation={handleDeleteConfirmation}
        deleteButtonLoading={deleteImageLoading}
        itemName={deleteFile?.name}
      />
      <div className="add-product-block">
        <Row>
          <Col xs={24}>
            <FormUpload
              name={keyNameAndValue?.value}
              // label={keyNameAndValue?.name}
              value={values[`${keyNameAndValue?.value}`]}
              handleChange={info => {
                const fileList = [...info.fileList];
                setFieldValue(keyNameAndValue?.value, fileList.length > 0 ? fileList : null);
              }}
              accept={getAcceptType()}
              // isMulti
              isRequired={false}
              onRemove={handleDeleteClick}
            />
          </Col>
        </Row>

        <DivBreak />
        <Divider />
        <Row justify="center" align="middle">
          <Button
            type="default"
            style={{ backgroundColor: '#155BDC', color: '#fff', height: '40px' }}
            onClick={e => {
              e.stopPropagation();
              cancelModal();
            }}
          >
            Save {keyNameAndValue?.name}
          </Button>
        </Row>
      </div>
    </>
  );
};

CarFieldForm.propTypes = {
  values: propTypes.object.isRequired,
  setFieldValue: propTypes.func.isRequired,
  keyNameAndValue: propTypes.object.isRequired,
  cancelModal: propTypes.func.isRequired,
  formData: propTypes.object.isRequired,
};

export default CarFieldForm;
